<template>
    <div>
        <div class="common-header">
            <div class="common-header-right">
                <div class="common-header-block">
                    <el-input
                            placeholder="请输入玩家ID或昵称"
                            v-model="searchVal">
                        <template slot="prepend">玩家ID或昵称</template>
                    </el-input>
                </div>
                <div class="common-header-block">
                    <el-date-picker
                            v-model="date"
                            format="yyyy-MM-dd HH:mm"
                            type="datetimerange"
                            range-separator="-"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"/>
                </div>
                <div class="common-header-block">
                    <el-button type="primary" @click="getList()">搜索</el-button>
                </div>
            </div>
        </div>

        <div class="common-table">
            <el-table v-loading="loading" :data="list" height="100%">
                <el-table-column type="index" label="编号" align="center"/>
                <el-table-column label="用户ID" width="120" align="center" prop="userId"/>
                <el-table-column label="俱乐部ID" align="center" prop="clubId"/>
                <el-table-column label="牌局ID" width="120" align="center" prop="roomId"/>
                <el-table-column label="牌局名称" width="150" align="center" prop="roomName"/>
                <el-table-column label="牌局类型" width="180" align="center" prop="roomPath"/>
                <el-table-column label="带入金豆" align="center" prop="takeIn"/>
                <el-table-column label="时间" width="180" align="center" prop="time"/>
                <el-table-column label="牌局创建者ID" width="150" align="center" prop="ownerId"/>
            </el-table>
        </div>
    </div>
</template>
<script>
    import {mapActions} from 'vuex'
    export default {
        data() {
            return {
                loading: false,
                date: null,
                searchVal: '',
                list: []
            }
        },
        methods: {
            ...mapActions('dataManage', ['getBringInfo']),
            parameterCalibration() {
                if (!this.date) {
                    this.$message.error('请选择时间');
                    return false
                }
                if (!this.searchVal) {
                    this.$message.error('请输入玩家ID或昵称');
                    return false
                }
                return true
            },
            getList(obj = {}) {
                if (!this.parameterCalibration()) return;
                this.loading = true;
                let params = {
                    user: this.searchVal,
                    startTime: this.date[0],
                    endTime: this.date[1],
                };
                Object.assign(params, obj);
                this.getBringInfo(params).then(res => {
                    this.list = res.data;
                    this.loading = false;
                })
            }
        }
    }
</script>